export default "__VITE_ASSET__BEMpntYz__"